import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Arch-1(a): branded type makes portal-session-token structurally incompatible
// with the internal-auth store's login(accessToken: string, user: User) signature.
// Any cross-store usage is a compile error (FN-TR-2 bug class closed at type level).
declare const PortalSessionTokenBrand: unique symbol;
export type PortalSessionToken = string & { readonly [PortalSessionTokenBrand]: typeof PortalSessionTokenBrand };

interface PortalAuthStore {
  vendorAccountId: string | null;
  sessionToken: PortalSessionToken | null;
  selectedTenantId: string | null;
  isPortalAuthenticated: boolean;

  login: (sessionToken: PortalSessionToken, vendorAccountId: string) => void;
  selectTenant: (tenantId: string) => void;
  logout: () => void;
}

export const usePortalAuthStore = create<PortalAuthStore>()(
  persist(
    (set) => ({
      vendorAccountId: null,
      sessionToken: null,
      selectedTenantId: null,
      isPortalAuthenticated: false,

      login: (sessionToken: PortalSessionToken, vendorAccountId: string) => {
        set({ sessionToken, vendorAccountId, isPortalAuthenticated: true });
      },

      selectTenant: (tenantId) => {
        set({ selectedTenantId: tenantId });
      },

      logout: () => {
        set({ vendorAccountId: null, sessionToken: null, selectedTenantId: null, isPortalAuthenticated: false });
      },
    }),
    {
      name: 'portal-auth',
      partialize: (state) => ({
        vendorAccountId: state.vendorAccountId,
        sessionToken: state.sessionToken,
        selectedTenantId: state.selectedTenantId,
        isPortalAuthenticated: state.isPortalAuthenticated,
      }),
    },
  ),
);
